import * as Routes from 'constants/Routes'

// All the navbar tab links in one place.
// Before, these lists were copied in several header and page files.
// `translation` is the text key in constants/Translations.js.
// Items with `isForManager: true` are hidden from viewers.

// `shortTranslation` is the label used on mobile, where the "Mis" prefix is
// dropped so the three tabs are short enough for the row.
export const workspaceNavItems = [
  { translation: 'myProjects', shortTranslation: 'projects', route: Routes.PROJECTS },
  { translation: 'myDevices', shortTranslation: 'devicesTitle', route: Routes.DEVICES },
  { translation: 'myIntegrations', shortTranslation: 'integrations', route: Routes.INTEGRATIONS }
]

export const projectNavItems = [
  { translation: 'dashboard', route: Routes.HOME, isForManager: false },
  { translation: 'shareables', route: Routes.FULLSCREEN, isForManager: true },
  { translation: 'alerts', route: Routes.ALERTS, isForManager: true },
  { translation: 'certifications', route: Routes.CERTIFICATIONS, isForManager: true },
  { translation: 'report', route: Routes.REPORTS, isForManager: true }
]
